var _path, _path2, _path3, _path4, _circle, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 136,
    viewBox: "0 0 126 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63 125C96.6894 125 124 97.6894 124 64C124 30.3106 96.6894 3 63 3C29.3106 3 2 30.3106 2 64C2 97.6894 29.3106 125 63 125Z",
    fill: "#BFDEA2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100 136H26V57.885C29.4879 57.8811 32.8318 56.5224 35.2981 54.1068C37.7644 51.6913 39.1516 48.4161 39.1556 45H86.8444C86.8408 46.6923 87.1797 48.3684 87.8418 49.9315C88.5039 51.4946 89.4758 52.9137 90.7015 54.1064C91.9193 55.3072 93.3681 56.2595 94.9643 56.9081C96.5604 57.5567 98.272 57.8887 100 57.885V136Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3992 102H52.5992C51.2737 102 50.1992 103.119 50.1992 104.5C50.1992 105.881 51.2737 107 52.5992 107H73.3992C74.7247 107 75.7992 105.881 75.7992 104.5C75.7992 103.119 74.7247 102 73.3992 102Z",
    fill: "#BFDEA2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6 112H45.4C44.0745 112 43 113.119 43 114.5C43 115.881 44.0745 117 45.4 117H80.6C81.9255 117 83 115.881 83 114.5C83 113.119 81.9255 112 80.6 112Z",
    fill: "#BFDEA2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 79,
    r: 18,
    fill: "#BFDEA2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63 87C67.4 87 71 83.4 71 79C71 74.6 67.4 71 63 71C58.6 71 55 74.6 55 79C55 83.4 58.6 87 63 87Z",
    stroke: "#76A140",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60 78.5L61.9976 81L66 76",
    stroke: "#76A140",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckData);
export default __webpack_public_path__ + "static/media/check-data.df166129d03aa6c32bf23ff507520788.svg";
export { ForwardRef as ReactComponent };